"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_tooltip_1 = require("@hotelplan/components.common.tooltip");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_context_feature_tooltips_1 = require("@hotelplan/libs.context.feature-tooltips");
const libs_mappers_1 = require("@hotelplan/libs.mappers");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const FeatureGroupTooltip_1 = __importDefault(require("./FeatureGroupTooltip"));
const ICON_WIDTH_MD = 28;
const ICON_HALF_WIDTH_MD = 10;
const TOOLTIP_CLASSNAME = 'tooltip';
const FEATURE_NAME_CLASSNAME = 'feature-summary-item-name';
const FeaturesSummaryList = styled_components_1.default.ul({
    display: 'flex',
    flexWrap: 'wrap',
});
const FeaturesSummaryItem = styled_components_1.default.li.attrs({
    'data-id': `features`,
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    mb: 2,
    mr: [3, 4],
    position: 'relative',
    alignItems: 'center',
    flexDirection: 'column',
    ':hover': {
        '.tooltip, .tooltipArrow': {
            visibility: 'visible',
            zIndex: 2,
        },
    },
}), ({ theme: { media }, theme }) => ({
    '.feature-summary-item-icon': Object.assign(Object.assign({}, theme.icons.md), { [media.tablet]: Object.assign({}, theme.icons.xlg) }),
}));
const FeaturesSummary = ({ groups, className, withName, successIcon, }) => {
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const featuresSummaryElRef = (0, react_1.useRef)(null);
    const { isEnabled, maxTooltipHeightPx, preventContainerOverlapping, } = (0, libs_context_feature_tooltips_1.useFeatureTooltipsContext)();
    (0, react_1.useEffect)(function adjustTooltipsPosition() {
        if (!featuresSummaryElRef.current || !preventContainerOverlapping)
            return;
        let featureNameElements;
        const tooltips = Array.from(featuresSummaryElRef.current.getElementsByClassName(TOOLTIP_CLASSNAME));
        if (withName) {
            featureNameElements = Array.from(featuresSummaryElRef.current.getElementsByClassName(FEATURE_NAME_CLASSNAME));
        }
        tooltips.map((tooltipEl, index) => {
            (0, components_common_tooltip_1.setTooltipPosition)(tooltipEl, {
                tooltipTargetObjectWidth: withName
                    ? featureNameElements[index].offsetWidth + ICON_WIDTH_MD
                    : ICON_WIDTH_MD,
                tooltipTargetObjectHalfWidth: withName
                    ? featureNameElements[index].offsetWidth / 2 + ICON_HALF_WIDTH_MD
                    : ICON_HALF_WIDTH_MD,
            });
        });
    }, [mobile, preventContainerOverlapping]);
    const enabledGroup = groups.filter(group => {
        const enabledFeatures = group.features.filter(f => f.enabled);
        return enabledFeatures.length > 0;
    });
    return (react_1.default.createElement(FeaturesSummaryList, { ref: featuresSummaryElRef, className: `productFeatures ${className || ''}` }, enabledGroup.map(({ id, name, features }, i) => {
        return (react_1.default.createElement(FeaturesSummaryItem, { className: "featureGroupWrapper", key: `${name}-${i}` },
            react_1.default.createElement(components_common_icon_1.Icon, { name: (0, libs_mappers_1.mapFeatureNameToIcon)(`${id}`), className: "feature-summary-item-icon", onClick: e => {
                    e.preventDefault();
                    e.stopPropagation();
                } }),
            withName && react_1.default.createElement("span", { className: FEATURE_NAME_CLASSNAME }, name),
            isEnabled && (react_1.default.createElement(FeatureGroupTooltip_1.default, { features: features, featureGroupName: name, maxTooltipHeightPx: maxTooltipHeightPx, successIcon: successIcon }))));
    })));
};
exports.default = FeaturesSummary;
//# sourceMappingURL=FeaturesSummary.js.map